import { faTimes } from '@fortawesome/free-solid-svg-icons';

import PaymentResult from 'page-components/subscriptions-tenant/modal/payment-result/PaymentResult';

const SubscriptionPaymentNotCompleted = () => {
  return <PaymentResult heading="PaymentNotCompleted" icon={faTimes} iconClassName="text-red1" />;
};

export default SubscriptionPaymentNotCompleted;
